import Toolbar from './Toolbar';

export default Toolbar;



// WEBPACK FOOTER //
// ./src/Toolbar/index.js